import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from '../Reveal';
import { ArrowMark, UnderlineMark } from '../Marks';
const BELIEFS = [{
  n: '01',
  title: 'Nivån finns redan här',
  text: 'Bagare, kockar, mejerister, rostare och bryggare som håller nationell klass. De behöver inte bli bättre — de behöver bli hittade.'
}, {
  n: '02',
  title: 'Utvalt, inte uppräknat',
  text: 'Vi listar inte alla. Vi har varit på ställena, betalat för maten och tagit ställning. Blir listan lång har vi gjort fel.'
}, {
  n: '03',
  title: 'En plats, inte femtio flikar',
  text: 'Beställa till kontoret, hitta rätt i en ny stad, köpa hem något gott. Samma ställe, samma smak, samma folk.'
}];
export function Mission() {
  return <section aria-labelledby="varfor" className="bg-black text-papper" data-id="element-575" data-mp="3qoxjamaioshy">
      <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-24" data-id="element-576" data-mp="3qp7a2c3dz3op">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr),minmax(0,1.05fr)] lg:gap-20" data-id="element-577" data-mp="3lr5s5uhp5aet">
          <Reveal data-id="element-578" data-mp="3k1u9p3vwqtry">
            <p className="text-[11px] font-bold uppercase tracking-wide3 text-smor" data-id="element-579" data-mp="3k2di9tzo45tb">Därför finns vi</p>
            <h2 id="varfor" className="display-xl mt-4 text-[2.8rem] uppercase leading-[0.9] sm:text-[4rem]" data-id="element-580" data-mp="3p05kphxxvabr">
              Det saknades en
              <span className="relative ml-3 inline-block" data-id="element-581" data-mp="1uxu1ss7jde9">
                mötesplats
                <UnderlineMark className="absolute -bottom-2 left-0 h-3 w-full text-rod" data-id="element-582" data-mp="6uafc93fkceq" />
              </span>
              .
            </h2>
          </Reveal>

          <Reveal delay={0.08} data-id="element-583" data-mp="brsre8cqv7qy">
            <div className="space-y-5 text-lg leading-relaxed text-papper/80 lg:pt-4" data-id="element-584" data-mp="br0wz0uvvg29">
              <p data-id="element-585" data-mp="gm6msarepevm">
                Vi tror att Småland har fler aktörer på riktigt hög nivå än vad landskapet någonsin får
                erkännande för. Bageriet i den lilla staden. Mejeriet vid vägen. Konditoriet som har gjort
                samma tårta i fyrtio år, och gör den bättre än någon annan.
              </p>
              <p className="text-papper" data-id="element-586" data-mp="2qmq93anjgv50">
                Problemet har aldrig varit kvaliteten. Det har varit att hantverken funnits var för sig,
                utspridda över ett helt landskap, utan en gemensam plats att mötas på.
              </p>
              <p data-id="element-587" data-mp="30edt4qhrn9wg">
                Så vi byggde den. Ett utvalt ställe där det småländska mathantverket står bredvid varandra
                — och där du kan beställa, besöka eller handla hem det, utan att först behöva veta vem du
                letar efter.
              </p>
            </div>
          </Reveal>
        </div>

        <ol className="mt-16 grid gap-10 border-t border-papper/20 pt-12 md:grid-cols-3" data-id="element-588" data-mp="35e8ksw9d83ik">
          {BELIEFS.map((belief, i) => <Reveal key={belief.n} delay={Math.min(i * 0.06, 0.18)} data-id="element-589" data-mp="3ec2j2cqox78d" data-mpi={i}>
              <li data-id="element-590" data-mp="3ear9txeh779v">
                <span className="display-xl block text-4xl text-smor" data-id="element-591" data-mp="1oxe7uetu5vbx">{belief.n}</span>
                <h3 className="mt-3 font-display text-2xl uppercase leading-tight" data-id="element-592" data-mp="1jyks0fr2ts8l">{belief.title}</h3>
                <p className="mt-3 leading-relaxed text-papper/70" data-id="element-593" data-mp="3vm6d55wsnxgr">{belief.text}</p>
              </li>
            </Reveal>)}
        </ol>

        <Reveal data-id="element-594" data-mp="4eaefba6axnc">
          <div className="mt-16 flex flex-wrap items-center gap-x-10 gap-y-6 border-t border-papper/20 pt-10" data-id="element-595" data-mp="4etsggwpd1w3">
            <p className="font-hand text-3xl text-smor sm:text-4xl" data-id="element-596" data-mp="3mrs079zqkz0t">
              Fan, här finns ju hur mycket gott som helst.
            </p>
            <Link to="/upptack" className="group ml-auto flex items-center gap-3 bg-papper px-8 py-4 text-[12px] font-bold uppercase tracking-wide2 text-black transition-colors duration-150 ease-out hover:bg-smor" data-id="element-597" data-mp="3cv5ekizl63xq">
              Se vilka som är med
              <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-598" data-mp="37vsir8qqlmj0" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>;
}